import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a20a980e1b0ab1a6cadfa74bc4e062cb7b from "./generated-cff406ee-2f27-4c43-9b9f-8361da417e8a.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/bookmaker-settings"){
            
                    await direct(a20a980e1b0ab1a6cadfa74bc4e062cb7b);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */